export class CarParkDriverRemoveModel {
  constructor ({ username = '', carParkId = -1 } = {}) {
    this.username = username
    this.car_park_id = carParkId
  }

  backendModel () {
    return {
      username: this.username,
      car_park_id: this.car_park_id
    }
  }
}
